import * as USER_TYPES from './user-types'

export const ROOT = '/'
export const HOME = '/home'
export const LOGIN = '/login'

export const USER_MANAGEMENT = '/user-management'
export const LATEST_POSTS = '/latest-posts'
export const ARTICLE_MANAGEMENT = '/article-management'
export const SITE_MANAGEMENT = '/site-management'
export const CATEGORY_MANAGEMENT = '/category-management'
export const DATASET_MANAGEMENT = '/dataset-management'
export const DISCOVERY_MANAGEMENT = '/discovery-management'
export const TAG_MANAGEMENT = '/tag-management'
export const HELP_MANAGEMENT = '/help-management'
export const INSIGHT_MANAGEMENT = '/insight-management'
export const WEBPAGE_MANAGEMENT = '/webpage-management'
export const USER_METRICS = '/user-metrics'
export const PREVIEW_ARTICLES = '/category/:categoryUuid/articles'
export const ARTICLE = '/article/:articleUuid'
export const SITE = '/site/:siteUuid'
export const DISCOVERY = '/discovery/:articleUuid'
export const HELP = '/help'
export const SEARCH_RESULTS = '/search-results/:searchTerm'
export const WEBPAGE = '/webpage/:articleUuid'
export const UNAUTHORISED = '/unauthorised-page'

export const DEFAULT = {
  [USER_TYPES.ADMIN]: HOME,
  [USER_TYPES.SUPER]: HOME,
  [USER_TYPES.GENERAL]: HOME
}
